import React from 'react';
import { Button } from 'reactstrap';
// import { IKRV_ATPLeadTimePropertiesQuantity } from '../../actions/customProxy/ATP/DataServiceEntities.g';
// import { CalculateEstDateAtpInput, estimatedAvailabilityAction } from '../../actions/calculate-est-date-atp.action';
import ATPESDMessageComponent from './atpESDMessage';
import { kRV_GetATPLeadTimeWithQuantityAsync } from '../../actions/customProxy/ATP1/DataActionExtension.g';
import { IKRV_GetATPLeadTimeResponseQuantity } from '../../actions/customProxy/ATP1/DataServiceEntities.g';

const EstimatedShipDateKitComponent: React.FC<any> = ({
    linkedProducts,
    itemNumber,
    propMax,
    context,
    trafficLightsResponse,
    anyChildWithRedLight
}) => {
    const [quanATP, setQuanAtp] = React.useState<number | undefined>();
    const [isLoadingAtpResponse, setIsLoadingAtpResponse] = React.useState<boolean>(false);
    const [atpResponse, setAtpResponse] = React.useState<IKRV_GetATPLeadTimeResponseQuantity | any>();
    const [isCalculateBtnDisable, setIsCalculateBtnDisable] = React.useState<boolean>(false);

    React.useEffect(() => {
        quanATP! < 1 ? setIsCalculateBtnDisable(true) : setIsCalculateBtnDisable(false);
        if (quanATP! > propMax && trafficLightsResponse?.StatusCode === '500') {
            setQuanAtp(propMax);
        } else if (quanATP! > propMax && trafficLightsResponse?.StatusCode === '502') {
            setQuanAtp(propMax);
        } else if (quanATP! > propMax && trafficLightsResponse?.StatusCode === '501') {
            setQuanAtp(propMax);
        } else if (quanATP! > propMax && trafficLightsResponse?.StatusCode === '503') {
            // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
            setQuanAtp(trafficLightsResponse?.Quantity + trafficLightsResponse.POQuantity);
        }
    }, [quanATP]);

    async function buttonATPCalculationDataActionCall() {
        setIsLoadingAtpResponse(true);
        try {
            //gathering all the child products payload
            const KRVATPLeadTimeChildsQuantity: any[] = linkedProducts.map((item: any) => {
                return {
                    itemID: item.ItemId,
                    Qty: String(item.Quantity * quanATP!)
                };
            });

            const context1 = { callerContext: context.actionContext };
            await kRV_GetATPLeadTimeWithQuantityAsync(context1, KRVATPLeadTimeChildsQuantity).then(res => {
                setAtpResponse(res);
                setIsLoadingAtpResponse(false);
            });
        } catch (error) {
            const errorBody: any = {
                Id: 0,
                ATPDate: '0',
                Message: 'Unable to get response for Estimated Availability',
                ExtensionProperties: []
            };
            setAtpResponse(errorBody);
            setIsLoadingAtpResponse(false);
        }
    }
    const handleCalculateATPDate = () => {
        if (itemNumber && quanATP) {
            void buttonATPCalculationDataActionCall();
        }
    };
    //These symbols are not be typed on input box
    const exceptThisSymbols = ['e', 'E', '+', '-', '.'];

    return (
        <>
            <div className='pdp-calculate-ship-container'>
                <label className='sr-only' htmlFor='atp-quantity-input'>
                    Enter Quantity
                </label>
                <input
                    className='calaculate-ship-input'
                    id='atp-quantity-input'
                    type='number'
                    value={quanATP}
                    placeholder='Enter Quantity'
                    onChange={(e: any) => {
                        setQuanAtp(e.target.value);
                    }}
                    onKeyDown={e => exceptThisSymbols.includes(e.key) && e.preventDefault()}
                />
                <Button
                    onClick={handleCalculateATPDate}
                    className={`${isCalculateBtnDisable ? 'disabled' : ''} calculate-ship-btn`}
                    disabled={
                        isLoadingAtpResponse ||
                        trafficLightsResponse?.TrafficLight! === 'Red' ||
                        anyChildWithRedLight ||
                        linkedProducts?.length !== 0
                    }
                >
                    Calculate Shipping Date
                </Button>
            </div>
            <ATPESDMessageComponent
                quanATP={quanATP}
                propMax={propMax}
                trafficLightsResponse={trafficLightsResponse}
                isLoadingAtpResponse={isLoadingAtpResponse}
                atpResponse={atpResponse}
            />
        </>
    );
};

export default EstimatedShipDateKitComponent;
